import { useLocalStorage } from '@vueuse/core';

const system = useLocalStorage('eve-log-current-system', '');

export function useCurrentSystem() {
  const { getSystemId } = useWormholes();

  const systemId = computed(() => {
    if (!system.value) return null;
    return getSystemId(system.value);
  });

  return { system, systemId };
}
